// Klaviyo Discount Code Integration (apply via cart/update.js)
class KlaviyoDiscountHandler {
    constructor() {
      this.isApplyingDiscount = false;
      this.lastAppliedCode = null;
      this.init();
    }
  
    init() {
      // Apply discount on page load
      this.applyDiscountFromCartbot();
      
      // Listen for cart events to apply discount when cart opens/changes
      this.listenForCartEvents();
    }
  
    listenForCartEvents() {
      // Listen for theme cart changes
      document.addEventListener('theme:cart:change', (event) => {
        if (!this.isApplyingDiscount) {
          this.applyDiscountFromCartbot();
        }
      });
      
      // Listen for cart drawer opening
      document.addEventListener('theme:drawer:open', (event) => {
        if (!this.isApplyingDiscount) {
          this.applyDiscountFromCartbot();
        }
      });
      
      // Listen for Upside cart built event
      document.addEventListener('Upside::UCD::CartBuilt', (event) => {
        if (!this.isApplyingDiscount) {
          this.applyDiscountFromCartbot();
        }
      });
      
      // Listen for add to cart events
      document.addEventListener('theme:cart:add', (event) => {
        // Apply discount after a short delay to ensure cart is updated
        setTimeout(() => {
          if (!this.isApplyingDiscount) {
            this.applyDiscountFromCartbot();
          }
        }, 500);
      });
    }
  
    applyDiscountFromCartbot() {
      try {
        const cartbotData = JSON.parse(localStorage.getItem('cartbot_data_cart') ||document.querySelector(
        'button[aria-label="Copy coupon code"]') || '{}');
        const discountCode = cartbotData.discount || cartbotData.discountCode;
  
        if (discountCode && discountCode !== this.lastAppliedCode) {
          this.applyDiscountToCart(discountCode);
        }
      } catch (err) {
        console.error("Error reading cartbot data:", err);
      }
    }
  
    applyDiscountToCart(code) {
      if (this.isApplyingDiscount) {
        return; // Prevent multiple simultaneous requests
      }
      
      this.isApplyingDiscount = true;
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
           body: JSON.stringify({ discount: code })

      })
      .then(res => res.json())
      .then(data => {
        console.log("Discount stored in cart attributes:", code, data);
        this.lastAppliedCode = code;
        
        // Only trigger cart reload if we're not already in a cart update cycle
        if (!this.isApplyingDiscount) {
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
        }
      })
      .catch(err => {
        console.error("Error applying discount:", err);
      })
      .finally(() => {
        this.isApplyingDiscount = false;
      });
    }
  }
  
  // Init
  document.addEventListener('DOMContentLoaded', () => {
    new KlaviyoDiscountHandler();
  });
  